import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinaryCareFetchAction from './veterinaryCareFetch.action.json' with { type: 'json' }
import { veterinaryCareObject } from '../veterinaryCareObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { protocolObject } from '~/packages/general/protocol/protocolObject'
import { veterinarianObject } from '../../veterinarian/veterinarianObject'
import { veterinaryExamObject } from '../../veterinaryExam/veterinaryExamObject'
import { veterinarySymptomObject } from '../../veterinarySymptom/veterinarySymptomObject'
import { veterinaryMedicationObject } from '../../veterinaryMedication/veterinaryMedicationObject'
import { residenceObject } from '~/packages/general/residence/residenceObject'

const veterinaryCareFetchDefinition = defineAction({
  ...veterinaryCareFetchAction,

  input: veterinaryCareObject.pick({
    id: true,
  }),
  output: veterinaryCareObject.extend({
    citizen: citizenObject.partial(),
    protocol: protocolObject.partial(),
    residence: residenceObject.partial(),
    veterinarian: veterinarianObject.extend({
      citizen: citizenObject,
    }),
    exams: z.array(veterinaryExamObject.nullish()),
    symptoms: z.array(veterinarySymptomObject.nullish()),
    medications: z.array(veterinaryMedicationObject.nullish()),
  }),
})

export default veterinaryCareFetchDefinition
